import React from 'react';
import { View } from 'react-native';
import PopupModal from '../PopupModal';
import { Tooltip_t } from '../common/tooltips/tooltips';

interface PopupModalWrapperProps {
  visible: boolean;
  tooltipData: Tooltip_t | null;
  buttons: Array<{ text: string; onPress: () => void }>;
  onClose: () => void;
}

const PopupModalWrapper: React.FC<PopupModalWrapperProps> = ({ visible, tooltipData, buttons, onClose }) => (
  <PopupModal
    tooltipData={tooltipData}
    visible={visible}
    buttons={buttons}
    onClose={onClose}
  />
);

export default PopupModalWrapper;
